/**
 * A model that holds the counts for a specific item:
 *      - devicegroup
 *      - product
 *      - account
 * From the API side, a counts call includes rollups or bulk responses
 * in addition to the counts for the individual item. For instance, a 
 * counts call for a single account includes the counts for products, 
 * devicegroups, and devices, but it also includes an 'items' parameter
 * which includes the counts for every product assigned to the account.
 *
 * For purposes of this Model (and the corresponding global collection q.v.)
 * each 'item' is its own Counts model and we will try to find it and update 
 * it in the global collection when we find it in an API response.
 *
 * This Counts Model uses many elements of the v5 parameters, but it's not
 * technically a v5_Model. It's not going to have relationships or includes.
 *
 * When instantiating a Counts model, include the type and the id of the thing 
 * whose counts this model represents. For example, when initializing the 
 * Counts for a product:
 *
 *      // resp is a response from an account.counts request
 *      _(resp.data.items).each(function(value, key) {
 *          var p = products.get(key) // A v5 Product
 *          if (!p.counts) p.counts = counts_collection.find(function(item) {
 *              return (item.id === p.id && item.get('type') === p.type);
 *          });
 *          p.counts.set(resp.data.items[key]);
 *      });
 */
import _ from 'underscore';
import Backbone from 'backbone';
import Api from '@/lib/api/api';

function update_global_counts(counts_collection, items, type) {
    if (!items) return; 
    if (!counts_collection) return console.warn('Couldn\'t find global counts collection');
    _(items).each(function(value, key) {
        var stored_item = counts_collection.get(key) 
                        || counts_collection.add({ id: key, type: type });
        stored_item.set(value);
    });
}
var Counts = Backbone.Model.extend({
    initialize: function(attrs, options) {
        this.type = options.type;
        this.item_type = options.item_type;
    },
    parse: function(resp, options) {
        var data = resp.data;
        if (data) {
            update_global_counts(this.collection, data.items, this.item_type);
            return _.chain({ type: this.type })
                .extend(data)
                .omit('items')
                .value();
        }
    },
    sync: function(method, model, options) {
        options = (options ? options : {});
        options.headers =  _.extend({
            'Content-type': 'application/vnd.api+json'
        }, options.headers);

        return Api.sync(method, model, options)
            .done(_.bind(verify_or_retry, this));
    },
});
function verify_or_retry(resp, textStatus, xhr) {
    if (xhr.status == '202') {
        // retry if the count is recalculating or out of date
        // Try in 1s increments
        setTimeout(_.bind(this.fetch, this), 2000);
    }
}
export default Counts;
